"use client";

import { useState, useEffect, useCallback } from "react";
import { handleDownloadBrochure } from "@/components/Course/utils";
import { Download } from "lucide-react";
import Link from "next/link";
import UserFormModal from "@/components/UserFormModal";
import ApplyButton from "./ui/ApplyButton";
// export const handleDownloadBrochure = (course) => {
//   const pdfUrl = course?.BrochurePdf?.url;
//   if (pdfUrl) {
//     const link = document.createElement("a");
//     link.href = pdfUrl;
//     link.download = course.BrochurePdf.name || "brochure.pdf";
//     link.target = "_blank";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   } else {
//     alert("Brochure is not available for download.");
//   }
// };

export default function CourseStickyBar({ coursePrice, onApply }) {
  const [isVisible, setIsVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [shouldDownload, setShouldDownload] = useState(false);

  // Scroll Visibility
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Download Handler
  // const handleCourseDownload = useCallback(() => {
  //   setShouldDownload(true);
  //   setOpen(true);
  // }, []);

  // const handleFormSuccess = useCallback(() => {
  //   if (shouldDownload && course) {
  //     handleDownloadBrochure(course);
  //     setShouldDownload(false);
  //   }
  // }, [shouldDownload, course]);

  return (
    <>
      {/* <UserFormModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onSuccess={handleFormSuccess}
        shouldDownload={shouldDownload}
      /> */}

      <div
        className={`
          fixed bottom-[70px]  md:bottom-0 left-0 right-0
          bg-gray-50 border-t border-gray-300
          py-1 md:py-4 z-998
          shadow-[0_-2px_8px_rgba(0,0,0,0.08)]
          transform transition-transform duration-300 ease-in-out
          page-container
          ${isVisible ? "translate-y-0" : "translate-y-full"}
        `}
      >
        <div className="flex flex-col md:flex-row justify-between gap-2">
          <div className="flex justify-between items-center w-full">
            <div className="flex flex-col">
              <p
                className="text-[18px] md:text-[20px] text-black"
                style={{ fontFamily: "saans-bold" }}
              >
                Programme Fee
              </p>
              <span
                className="text-[18px] md:text-[20px] text-black"
                style={{ fontFamily: "saans-bold" }}
              >
                {coursePrice?.price || ""}
              </span>
            </div>

            {/* <div className="flex items-center shrink-0">
              <ApplyButton text={"Apply now"} onClick={onApply} />
            </div> */}

            <div className="flex items-center shrink-0">
              <Link
                href="https://application.msu.edu.in/msu-industry-co-led-application-form"
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer bg-[#FFA201] px-6 py-2 text-[14px] text-black rounded-none transition hover:bg-[#e89500]"
              >
                Apply Now
              </Link>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}